/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rate_Prompt_Rate_NowInputs */

const en_rate_prompt_rate_now = /** @type {(inputs: Rate_Prompt_Rate_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rate now`)
};

const es_rate_prompt_rate_now = /** @type {(inputs: Rate_Prompt_Rate_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calificar ahora`)
};

/**
* | output |
* | --- |
* | "Rate now" |
*
* @param {Rate_Prompt_Rate_NowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const rate_prompt_rate_now = /** @type {((inputs?: Rate_Prompt_Rate_NowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rate_Prompt_Rate_NowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_rate_prompt_rate_now(inputs)
	return en_rate_prompt_rate_now(inputs)
});